module.exports = __webpack_public_path__ + "img/AC.24f1aff8.svg";